import React, { useEffect, useMemo, useState } from "react";
import "./doctor.css";
import { useTranslation } from "../../shared/LanguageContext";
import { BASE_URL } from "../../config";

// Докторские карточки
const Doctor = ({ doctorsList = [] }) => {
    const { language, t } = useTranslation();
    
    // Нормализуем вход: гарантируем массив картинок длиной ≤ 3
    const list = useMemo(
        () =>
            (doctorsList || []).map((d) => ({
                ...d,
                images: Array.isArray(d.images) ? d.images.filter(Boolean).slice(0, 3) : [],
                _key: d._id || d.id || `${d.name || "doc"}-${Math.random().toString(36).slice(2, 8)}`,
            })),
        [doctorsList]
    );

    // Индексы фото на каждую карточку
    const [photoIndexes, setPhotoIndexes] = useState(list.map(() => 0));
    const [expandedIndex, setExpandedIndex] = useState(-1);

    // Синхронизируем длину индексов при изменении списка/кол-ва фото
    useEffect(() => {
        setPhotoIndexes((prev) =>
            list.map((d, i) => {
                const max = Math.max(0, (d.images?.length || 1) - 1);
                const cur = prev[i] ?? 0;
                return Math.min(cur, max);
            })
        );
        if (expandedIndex >= list.length) setExpandedIndex(-1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list.length, JSON.stringify(list.map((d) => d.images?.length || 0))]);

    const handleArrowClick = (doctorIdx, direction) => {
        const images = list[doctorIdx]?.images || [];
        const len = images.length || 1;
        if (len <= 1) return;
        setPhotoIndexes((prev) =>
            prev.map((idx, i) => {
                if (i !== doctorIdx) return idx;
                if (direction === "prev") return (idx - 1 + len) % len;
                return (idx + 1) % len;
            })
        );
    };

    const handleToggleExpand = (idx) => {
        setExpandedIndex(expandedIndex === idx ? -1 : idx);
    };

    return (
        <>
            {list.map((doctor, index) => {
                const hasImages = doctor.images && doctor.images.length > 0;
                const currentImgPath = hasImages ? doctor.images[photoIndexes[index]] : null;
                const currentImg = currentImgPath 
                    ? (currentImgPath.startsWith('http') || currentImgPath.startsWith('data:') ? currentImgPath : `${BASE_URL}${currentImgPath}`)
                    : null;

                return (
                    <div
                        className="doctor-container"
                        key={doctor._key || index}
                        style={{ position: "relative" }}
                        onClick={() => handleToggleExpand(index)}
                    >
                        <div className="doctor-image" style={{ position: "relative", overflow: "hidden" }}>
                            {hasImages ? (
                                <img
                                    src={currentImg}
                                    alt={doctor[`name_${language}`] || doctor.name}
                                    style={{ width: 310, height: 348, objectFit: "cover", borderRadius: 12 }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: 310,
                                        height: 348,
                                        borderRadius: 12,
                                        background:
                                            "linear-gradient(135deg, rgba(121,99,128,0.25), rgba(121,99,128,0.08))",
                                        display: "grid",
                                        placeItems: "center",
                                        color: "#2d2d38",
                                        fontSize: 14,
                                        fontWeight: 600,
                                    }}
                                >
                                    Фото отсутствует
                                </div>
                            )}

                            {hasImages && doctor.images.length > 1 && (
                                <>
                                    <button
                                        className="carousel-arrow left-arrow"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleArrowClick(index, "prev");
                                        }}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: 8,
                                            transform: "translateY(-50%)",
                                            background: "#fff9",
                                            border: "none",
                                            borderRadius: "50%",
                                            padding: 7,
                                            cursor: "pointer",
                                            zIndex: 2,
                                        }}
                                    >
                                        <i className="fas fa-chevron-left" style={{ fontSize: 18 }} />
                                    </button>
                                    <button
                                        className="carousel-arrow right-arrow"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleArrowClick(index, "next");
                                        }}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: 8,
                                            transform: "translateY(-50%)",
                                            background: "#fff9",
                                            border: "none",
                                            borderRadius: "50%",
                                            padding: 7,
                                            cursor: "pointer",
                                            zIndex: 2,
                                        }}
                                    >
                                        <i className="fas fa-chevron-right" style={{ fontSize: 18 }} />
                                    </button>
                                </>
                            )}
                        </div>

                        <div className="doctor-details">
                            <h6>{doctor[`name_${language}`] || doctor.name}</h6>
                            <p>{doctor[`department_${language}`] || doctor.department}</p>
                        </div>

                        {expandedIndex === index && (
                            <div className="doctor-detail-card" onClick={(e) => e.stopPropagation()}>
                                <div style={{ margin: "8px 0" }}>{doctor[`description_${language}`] || doctor.description}</div>
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default Doctor;
